// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel[data-v-b218f4b8] {\n  display: flex;\n  justify-content: center;\n  flex-direction: row-reverse;\n  margin-top: 10px;\n}\n.R[data-v-b218f4b8] {\n  width: 16.5rem;\n  margin-left: 8px;\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
